<template>
  <div class="context-menu-main settings-main-tiles">
    <div
      class="settings-menu__overlay"
      v-show="$loader.isLoading('processMenuData')"
    >
      <spinner
        line-fg-color="#313942"
        line-bg-color="#eee"
        message="Menu wird geladen"
        :spacing="10"
        :size="16"
      ></spinner>
    </div>
    <div class="settings-header" v-if="showTree">Alle Regionen</div>
    <div class="custom-tree-container" v-if="showTree">
      <div class="custom-tree-container">
        <div class="block">
          <el-tree
            :data="menu"
            node-key="id"
            :default-expanded-keys="menuExpandedKeys"
            :expand-on-click-node="false"
          ></el-tree>
          <!-- default-expand-all -->
        </div>
      </div>
    </div>

    <div v-else>
      <!-- Gewählte Einträge -->
      <div
        class="sbh-menu-list__item selected-red-border"
        v-for="selectedItem in selectedItems"
        :key="selectedItem.id"
      >
        <div
          :class="
            `sbh-menu-list__item__content item-selected ${
              selectedItem._opacity
            }`
          "
        >
          <p class="sbh-menu-list__item-header">{{ selectedItem.label }}</p>
          <span class="item-selected-bezirke">ausgewählt</span>
        </div>
        <div
          :class="
            `application-list__item__close hover ${selectedItem._opacity}`
          "
          @click="unselectItem()"
        >
          <i class="far fa-times" />
        </div>
      </div>

      <!-- Menu -->
      <div class="sbh-menu-list">
        <div
          class="sbh-menu-list__item selected-hover-red-border animated fadeIn"
          v-for="menuItem in menuItems"
          :key="menuItem.id"
        >
          <div
            class="sbh-menu-list__item__content hover"
            @click="selectItem(menuItem.id)"
            v-if="!menuItem.applicationId"
          >
            <p class="sbh-menu-list__item-header">{{ menuItem.label }}</p>
            <span class="sbh-menu-list__item-info">bitte auswählen</span>
          </div>
          <div v-else>
            <router-link
              :to="'/main/application/' + menuItem.applicationId"
              @click.native="selectItem(menuItem.id)"
              class="application-link"
            >
              <div class="sbh-menu-list__item__content hover">
                <p class="sbh-menu-list__item-header">{{ menuItem.label }}</p>
                <span class="sbh-menu-list__item-info">bitte auswählen</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import router from "../router";

export default {
  name: "contentMenu",
  components: {
    Spinner
  },
  props: {
    applications: Array,
    menu: Array,
    menuTitle: String,
    menuFirstItemId: String
  },
  data() {
    return {
      menuExpandedKeys: [1],
      showTree: false,
      showTiles: true,
      selectedNode: "",
      menuItems: [],
      selectedItems: [],
      menuIds: { menu_1000: "menu_2000" },
      counter: 0
    };
  },
  mounted() {
    this.selectMenuItems();
  },
  methods: {
    selectItem(nodeId) {
      let newMenu = [];
      let itemSelected = false;
      let selectedItem = {};
      let selectedApplicationId = null;

      this.selectedNode = nodeId;

      if (this.counter === 0) {
        this.$store.state.contentMenuItems = [];
      }
      this.menuItems.forEach(function(menuItem) {
        if (menuItem.id === nodeId) {
          if (menuItem.applicationId) {
            itemSelected = true;
            selectedApplicationId = menuItem.applicationId;
          }
          newMenu = menuItem.children;
          selectedItem = menuItem;
        }
      });
      if (itemSelected) {
        this.$store.state.contentMenuData = {
          applicationId: selectedApplicationId,
          menuTitle: this.menuTitle,
          menuFirstItemId: this.menuFirstItemId,
          menuItems: this.menuItems
        };

        this.$emit("fetchApplicationDevices", selectedItem.applicationId);
      } else {
        this.menuItems = newMenu;
        this.$store.state.contentMenuItems.push(selectedItem);
        this.$store.state.contentMenuItems.forEach(function(si) {
          if (si.id !== selectedItem.id) {
            si._opacity = "menu-opacity-06";
          }
        });
        this.selectedItems = this.$store.state.contentMenuItems;
      }
      this.counter++;
    },
    unselectItem() {
      this.menuItems = this.menu;
      if (this.menuItems.length > 0) {
        this.menuItems.forEach(function(si) {
          si._opacity = "";
        });
      }
      this.selectedItems = [];
      this.$store.state.contentMenuItems = [];
      this.$emit("unselectItem");
    },
    selectMenuItems() {
      //fetch application devices
      if (
        this.$store.state.contentMenuData.applicationId &&
        this.$store.state.contentMenuData.menuTitle
      ) {
        this.$emit(
          "fetchApplicationDevices",
          this.$store.state.contentMenuData.applicationId
        );
        router.push(
          `/main/application/${this.$store.state.contentMenuData.applicationId}`
        );
      }
      //select menu
      if (this.menuTitle === this.$store.state.contentMenuData.menuTitle) {
        this.selectedItems = this.$store.state.contentMenuItems;
        this.menuItems = this.$store.state.contentMenuData.menuItems;
        this.$root.$emit(
          "bv::toggle::collapse",
          this.menuIds[this.$store.state.contentMenuData.menuFirstItemId]
        );
      }

      if (
        (!this.$store.state.contentMenuData.applicationId &&
          !this.$store.state.contentMenuData.menuTitle) ||
        (this.$store.state.contentMenuData.menuTitle &&
          this.$store.state.contentMenuData.menuTitle !== this.menuTitle)
      ) {
        this.menuItems = this.menu;
      }
    }
  }
};
</script>
